import Enum from "@/util/enum";
import EnumValue from ".";

export default class SearchScope extends Enum {
  static UNKNOWN: EnumValue = { name: "Unknown", code: 0 };
  static FAMILYMEMBERS: EnumValue = { name: "Family members", code: 1 };
  static MATCHINGDONORS: EnumValue = { name: "Matching donors", code: 2 };
  static BOTH: EnumValue = { name: "Both", code: 3 };
}
